import React from "react";
import SocietySideNav from "./navBarSocietyDashbard/navBarSocietyDashbard";
import "./societyLayout.css";

const SocietyLayout = ({ children }) => {
  return (
    <div className="society-layout">
      <SocietySideNav />
      <main className="society-main">{children}</main>
    </div>
  );
};

export default SocietyLayout;